<template>
	<div>
		<div class="sf-search-layout__body__container">
			<sf-search-layout>
				<el-row :gutter="20">
					<!-- 기간 단위 -->
					<el-col :span="2">
						<select-combo
							:label="getMessage_('QWCC002008')"
							paramKey="period"
							:options="searchCategory"
							:propData="searchParams.period"
							@commChange="setSearchParam"
							:showAll="false"
						></select-combo>
					</el-col>
					<!-- 검사기간 -->
					<el-col :span="3">
						<div class="sf-input-group-wrapper">
							<span class="sf-input-group-wrapper__label">{{ getMessage_('QWCC001224') }}</span>
							<el-date-picker
								:value="searchParams.strDt"
								@input="value => setSearchParam({ key: 'strDt', value })"
								:type="searchParams.period === 'month' ? 'year' : 'month'"
								:value-format="searchParams.period === 'month' ? 'yyyy' : 'yyyyMM'"
								:placeholder="getMessage_('QWCC001224')"
							/>
						</div>
					</el-col>
					<!-- 품번 -->
					<el-col :span="4">
						<search-input
							:label="getMessage_('QWCC000956')"
							paramKey="partNm"
							@commInput="setSearchParam"
							:clearable="false"
							:propData="searchParams.partNm"
						>
							<template v-slot:icon> <i class="icon-sf-search search-icon" @click="onPartPopup"></i></template>
						</search-input>
					</el-col>
					<!-- 소싱구분 -->
					<el-col :span="4">
						<select-combo
							:label="getMessage_('QWCC000981')"
							paramKey="partGCd"
							:options="partGCdList"
							:propData="searchParams.partGCd"
							@commChange="setSearchParam"
						></select-combo>
					</el-col>
					<!-- 발생장소 -->
					<el-col :span="4">
						<select-combo
							:label="getMessage_('QWCC001464')"
							paramKey="occuPlCd"
							:options="occuPlCdList"
							:propData="searchParams.occuPlCd"
							@commChange="setSearchParam"
						></select-combo>
					</el-col>
				</el-row>
				<template slot="button">
					<sf-button line icon="search" :onClick="searchList" v-if="isButton_(scrId, 'CR')">
						{{ getButtonMsg_(scrId, 'CR') }}
					</sf-button>
				</template>
			</sf-search-layout>
		</div>
		<part-mng-popup ref="partMngPopup" @SendData="sendData" :scrId="scrId"></part-mng-popup>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';
import SearchInput from '@qms/Components/SearchInput';
import SelectCombo from '@qms/Components/SelectCombo';
import PartMngPopup from '@qms/comm/commpopup/PartMngPopup/PartMngPopup.vue';
export default {
	props: { scrId: { type: String, default: '' } },
	data() {
		return {
			searchCategory: []
		};
	},
	components: { SearchInput, SelectCombo, PartMngPopup },
	async created() {
		this.searchCategory = [
			{ label: this.getMessage_('QWCC002006'), value: 'day' },
			{ label: this.getMessage_('QWCC002007'), value: 'month' }
		];
		try {
			await this.getCommCodes_({ key: 'partGCdList', codeType: 'PART_G' }); //소싱구분;
			await this.getCommCodes_({ key: 'occuPlCdList', codeType: 'OCCU_PL' }); //발생장소;
			await this.searchList();
		} catch (error) {
			this.$sf_toast({ type: 'error', message: error?.message || error });
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		setSearchParam({ key, value }) {
			this.setSearchParam_({ key, value });
			if (key === 'period') {
				const result = value === 'month' ? this.$moment().format('YYYY') : this.$moment().format('YYYYMM');
				this.setSearchParam_({ key: 'strDt', value: result });
			}
			if (key === 'partNm') {
				this.setSearchParam_({ key: 'partNo', value: '' });
			}
		},
		onPartPopup() {
			this.$refs.partMngPopup.open(this.searchParams.partNo);
		},
		//협력사조회 팝업
		onPqyCpnyPopup() {
			let params = {
				cpnyScn: '10',
				cpnyCd: this.searchParams.cofCd
			};
			this.$refs.compPopup.open(params);
		},
		sendData({ partNo }) {
			this.setSearchParam_({ key: 'partNo', value: partNo });
		},
		async searchList() {
			this.$sf_toggleLoading(true);
			try {
				await this.getList_();
				await this.getGraph_();
				this.setState_({ key: 'detailList', value: [] });
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error?.message || error });
			} finally {
				this.$emit('doLoad');
				this.$sf_toggleLoading(false);
			}
		}
	},
	computed: { ...rootComputed, ...serviceComputed }
};
</script>

<style></style>
